'use client';
import React, { Dispatch, SetStateAction } from 'react';

import Image from 'next/image';
import closeIcon from '@images/ico_close_primary.svg';
import { BlogNewsProp } from '@/services';
import * as ContentWithCTA from '@components/content-with-cta';
import { convertToCdn } from '@lib/utils';
import { TrackedAnchor } from '@/components/ancher';
import { TrackedButton } from '@/components/button';
import { ModalWrapper } from '@/components/modal';

function DownloadPopup({
  isOpen,
  setIsOpen,
  post,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  post: BlogNewsProp | null;
}) {
  const safeUrl = convertToCdn(post?.popupImage || '');

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      ariaLabelledBy="blog-download-popup-title"
    >
      <div className="relative flex h-[460px] w-[350px] flex-col 2xl:h-[350px] 2xl:w-[700px] 2xl:flex-row-reverse">
        <TrackedButton
          label={`popup_close`}
          position="main_content"
          onClick={() => {
            setIsOpen(false);
          }}
          className="bg-opacity-51 absolute right-4 top-4 w-8 rounded-lg bg-[#F3F5FC] p-2"
        >
          <Image src={closeIcon} alt="" priority />
        </TrackedButton>
        <div className="h-[200px] w-[350px] 2xl:ml-[-1px] 2xl:h-[350px]">
          {safeUrl && (
            <Image
              src={safeUrl}
              alt=""
              width={350}
              height={350}
              className="rounded-t-2xl object-none 2xl:rounded-none 2xl:rounded-r-2xl"
              priority
            />
          )}
        </div>
        <div className="flex flex-col items-center rounded-b-2xl bg-3b-background-surface p-8 2xl:w-[calc(50%)] 2xl:rounded-none 2xl:rounded-l-2xl 2xl:pr-2">
          <h3
            id="blog-download-popup-title"
            className="whitespace-normal break-keep text-h5 2xl:text-h4"
          >
            {post?.popupTitle}
          </h3>
          <div className="h-3" />
          <p className="whitespace-normal break-keep text-sh2 font-medium text-3b-text-secondary 2xl:text-sh1">
            {post?.popupText}
          </p>
          <div className="h-5" />
          <ContentWithCTA.ButtonWrapper>
            <TrackedAnchor
              label={`popup_cta`}
              position="main_content"
              href={post?.popupLink || ''}
              target="_blank"
              className="rounded-[40px] bg-[#040435] px-[22px] py-[12px] text-sm font-bold text-white hover:bg-3b-red-light-600 focus:bg-[#003CB3] active:bg-3b-red-light-600 disabled:bg-[#c0bccc] lg:min-w-[215px] lg:px-[42px] lg:py-[17px] lg:text-base 2xl:min-w-max"
            >
              {post?.popupButton}
            </TrackedAnchor>
          </ContentWithCTA.ButtonWrapper>
        </div>
      </div>
    </ModalWrapper>
  );
}

export default DownloadPopup;
